import { Logo } from "@/components/Navbar";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <Logo light />
          <p className="mt-4 text-sm text-slate-400 max-w-xs leading-relaxed">
            Reparation, opbygning, opsætning og vejledning inden for IT, HiFi og hjemmeelektronik —
            både ude og inde.
          </p>
          <p className="mt-4 text-lg font-display font-black tracking-tight text-white">
            Følger <span className="text-blue-500">DIT</span> behov.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Ydelser</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>IT-support & reparation</li>
            <li>HiFi & lydanlæg</li>
            <li>Smart home & elektronik</li>
            <li>3D-print</li>
            <li>Robotplæneklippere</li>
            <li><Link to="/betingelser" data-testid="footer-terms-link" className="hover:text-blue-400 transition-colors">Serviceaftale – betingelser</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Kontakt</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-blue-500" /> jkljohansen90@gmail.com</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-blue-500" /> Ring for aftale</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-blue-500" /> Service ude & inde</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} J-Computer. Alle rettigheder forbeholdes.
      </div>
    </footer>
  );
}
